import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
  selector: '[tt-payment-method-host]',
})
export class PaymentMethodDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}
